export { default as CreacionTraslado } from "./CreacionTraslado";
